module.exports = __webpack_public_path__ + "media/images/icon__search--rb-gray@3x-56633ed578d94fd5a246aefbb8f81dea.png";